'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var safelyCallFunction = exports.safelyCallFunction = function safelyCallFunction(func) {
    return function () {
        if (typeof func !== 'function') return false;

        return func.apply(undefined, arguments);
    };
};

var getActionValues = exports.getActionValues = function getActionValues(action) {
    return action.payload && action.payload.values;
};

var rotateArray = exports.rotateArray = function rotateArray(array) {
    var clockwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var startPos = clockwise ? array.length - 1 : 0;
    var arrayCopy = array.slice();
    var firstElem = arrayCopy.splice(startPos, startPos + 1);
    return clockwise ? firstElem.concat(arrayCopy) : arrayCopy.concat(firstElem);
};

var toArray = exports.toArray = function toArray(element) {
    return [].concat(element);
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-promising-modals/lib/utils.js
// module id = 123
// module chunks = 0